import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["value", "type", "name", "maxlength", "disabled", "placeholder"]
const _hoisted_2 = {
  key: 0,
  class: "revico-community-talk-custom-input-error-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("input", {
      value: $props.modelValue,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', ($event.target as any).value))),
      type: $props.type,
      name: $props.name,
      maxlength: $props.maxlength,
      disabled: $props.disabled,
      placeholder: $props.placeholder,
      class: _normalizeClass(`${$props.customClass} ${$setup.defaultClass}`)
    }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1),
    ($props.apiValidationErrorViewModel)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($setup.errorMessage), 1 /* TEXT */))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}